export { default } from './BancoDoAuto25Blog';
